import script from "./SelectInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectInput.vue?vue&type=script&setup=true&lang=js"

import "./SelectInput.vue?vue&type=style&index=0&id=33b54d17&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33b54d17"]])

export default __exports__